import { HttpClient } from "@/App/services/httpClient/HttpClient";
import type { CandidateEmsUser } from "./CandidateEmsUser";

export const DispatchService = {
  getUsers({ caseId }: { caseId: string }): Promise<CandidateEmsUser[]> {
    return HttpClient.get<CandidateEmsUser[]>({
      path: `/twiageCases/${caseId}/candidateEmsUsers`,
    });
  },
  selectUserAsCandidate({ caseId, userIds }: { caseId: string; userIds: string[] }): Promise<CandidateEmsUser[]> {
    return HttpClient.post<CandidateEmsUser[]>({
      path: `/twiageCases/${caseId}/candidateEmsUsers`,
      body: { userIds },
    });
  },
  removeUserAsCandidate({ caseId, userIds }: { caseId: string; userIds: string[] }): Promise<CandidateEmsUser[]> {
    return HttpClient.delete<CandidateEmsUser[]>({
      path: `/twiageCases/${caseId}/candidateEmsUsers`,
      body: { userIds },
    });
  },
};
